import logo from './logo.svg';
import './App.css';

import { BrowserRouter, Route, Routes, Navigate, useSearchParams, useNavigate } from "react-router-dom";
import Loginpage from './pages/Loginpage';
import ForgotPassword from './pages/ConfigPages/ForgotPassword';
import ResetPassword from './pages/ConfigPages/ResetPassword';
import ChangePassword from './pages/ConfigPages/ChangePassword';
import PrivacyNoticePage from './pages/PrivacyNoticePage';
import Homepage from './pages/Homepage';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import{ useState } from "react";
import CustomDialogBox from "../src/pages/CommonComponents/CustomDialogBox";
import axios from "axios";
function RequireAuth({children}) {
  const logindata = useSelector((state) => state.logindata.userprops)
  return logindata.userauthstate === 1 ? children : <Navigate to='/' replace/>
}

function App() {
  const [errorTitle,setErrorTitle] = useState("Error");
  const [errorText,setErrorText] = useState("An unexpected error occurred. Please try again later.");
  const [showForbidden, setShowForbidden] = useState(false);
  useEffect(() => {
  // Setup Axios interceptor for 403
  const interceptor = axios.interceptors.response.use(
    response => response,
    error => {
      if (error.response && error.response.status === 403) {
        setShowForbidden(true);
        setErrorTitle("Forbidden Access");
        setErrorText("You don't have permission to access this resource.");

      }
      if (error.response && error.response.status === 401) {
        setShowForbidden(true);
        setErrorTitle("Authorization Error");
        setErrorText(error.response.data.error);

      }
      // Optionally, you can handle other status codes here
      return Promise.reject(error);
    }
  );
  return () => axios.interceptors.response.eject(interceptor);
}, []);
  return (
    <div className="App">
      <CustomDialogBox
        dialogTitle={errorTitle}
        dialogText={errorText}
        openDialog={showForbidden}
        handleConfirmDialog={() => setShowForbidden(false)}
        confirmText={"OK"}
        type={"Warning"}
      />
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Loginpage/>} />
          <Route path='/forgetPassword' element={<ForgotPassword />} />
          <Route path='/reset-password' element={<ResetPassword/>} />
          <Route path='/changepassword' element={<ChangePassword />} />
          <Route path='/privacy-notice' element={<PrivacyNoticePage />} />
          <Route path="/home" element={<RequireAuth> <Homepage/> </RequireAuth>}>
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
